import { DEFAULT_FONT_SIZE } from "./constants";
import { isNumberFormat, normalizeCellValue } from "./values";

/**
 * Sets header alignment: top-level sections centered, numeric columns right-aligned.
 */
export function applyHeaderAlignment(cell, th, isTopLevelHeaderRow) {
  if (isTopLevelHeaderRow) {
    cell.alignment = {
      ...cell.alignment,
      horizontal: "center",
      vertical: "middle",
    };
    return;
  }

  const exportFormat = th.getAttribute("data-export-type");
  const inlineAlign = th.style?.textAlign;
  const isRightAligned =
    inlineAlign === "right" ||
    inlineAlign === "end" ||
    (exportFormat && isNumberFormat(exportFormat));

  const horizontal =
    inlineAlign === "center" ? "center" : isRightAligned ? "right" : "left";

  cell.alignment = {
    ...cell.alignment,
    horizontal,
    vertical: "middle",
  };
}

/**
 * Applies font, underline/strike, indent, and fill from table data-* attributes.
 */
export function applyCellStyles(cell, td, isNumberFormatCell) {
  const {
    fBold,
    fItalic,
    aIndent,
    fillColor,
    color,
    aStrikethrough,
    aUnderline,
  } = td?.dataset ?? {};

  cell.font = {
    bold: fBold,
    italic: fItalic,
    color: { argb: color },
    size: DEFAULT_FONT_SIZE,
  };

  if (aStrikethrough) {
    cell.font.strike = true;
  } else if (aUnderline) {
    cell.font.underline = true;
  }

  if (aIndent && !isNumberFormatCell) {
    cell.alignment = { indent: aIndent };
  }

  if (fillColor) {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: fillColor },
    };
  }
}

/**
 * Sets cell value, numFmt, and alignment from data-export-raw-value / data-export-type.
 * @returns {boolean} Whether the cell uses a number format (affects indent styling).
 */
export function applyCellFormat(cell, td) {
  const rawValue = td.getAttribute("data-export-raw-value");
  const format = td.getAttribute("data-export-type");

  if (!format) return false;

  cell.value = normalizeCellValue(rawValue, format);
  cell.numFmt = format;

  if (isNumberFormat(format)) {
    cell.alignment = { horizontal: "right" };
  }

  return isNumberFormat(format);
}
